import { render, staticRenderFns } from "./RiskMethodology.vue?vue&type=template&id=518a9cd4&"
import script from "./RiskMethodology.vue?vue&type=script&lang=js&"
export * from "./RiskMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports